module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_02_770_280_ko-55c6afaf8fa05bb9ae53ff822d2a2cd4.jpg";